import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=9a275cd2&scoped=true&"
import script from "./NotificationDetail.vue?vue&type=script&lang=js&"
export * from "./NotificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=9a275cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a275cd2",
  null
  
)

export default component.exports